import React, { useState, useEffect, useCallback } from "react"
import tooltip from "@/public/icons/tooltip-new.svg"

import qs from "qs"
import _get from "lodash/get"
import { useDispatch } from "react-redux"
import { getShortenedUrl, getShortenedUrlwithGeneral } from "@/utils/helper"
import { getStock } from "@/utils/cart"
import { apim } from "@/constants/api"
import { getConfig } from "@/constants/config"
import { addDataLayer } from "../../ProductDetailView/analytics"
import MissingImage from "@/public/images/image-missing.png"
import SelectYourStyleView from "./SelectYourStyle.view"
import { updateVariantSkuInTabDetails } from "@/store/features/pdpSlice"

const SelectYourStyle = ({
  i18n,
  imageDetails,
  selectOption,
  setSkuVariant,
  colorDiscontinuedVarients,
  isDiscontinued,
  customLabelDetails,
  isColorDiscontinued,
  productTitle,
  authorData,
  descriptionDetails = [],
  lwAppName = "",
  ProductLocalCategory = "",
  productCollection = "",
  availableColors = [],
  priceData = [],
  isCollapsedPDP,
  productImages,
  ...props
}) => {
  let currentSku = props?.currentSku ? props?.currentSku : ""

  const [colorHeading, setColorHeading] = useState(null)
  const [showModal, setShowModal] = useState(false)
  const [isShape, setModalShape] = useState(false)
  const [shapeHeading, setShapeHeading] = useState(null)
  const [isColor, setModalColor] = useState(false)
  const [showFilter, setModalFilter] = useState(false)
  const [colors, setColors] = useState([])
  const [colorsPopUp, setColorsPopUp] = useState([])
  const [finish, setFinish] = useState([])
  const [colorFamily, setColorFamily] = useState([])
  const [colorFamilyCount, SetColorFamilyCount] = useState([])
  const [activeSku, setActiveSku] = useState("")
  const [CONFIG, setCONFIG] = useState({})
  const [general, setGeneral] = useState({})
  const [colorsDiscontinuedVarients, setDiscontinuedColors] = useState(
    colorDiscontinuedVarients
  )
  const [discontinuedCTALink, setDiscontinuedCTALink] = useState("")
  const [finalAvailableColors, setAvailableColors] = useState([])
  const [image, setImage] = useState([])
  const [styleTooltip, setSelectStyleTooltip] = useState({
    shareTooltip: false,
    colorTooltip: false,
    finishTooltip: false,
    vanityTooltip: false,
  })
  const SHOWALL = "Show All"
  const NO_FINISH_TYPE = "noFinishType"
  const [tooltipdata, setTooltipData] = useState([])
  const finishType =
    props?.finishType?.length > 1
      ? [SHOWALL, ...props.finishType]
      : props?.finishType
  let styleOptionsNotPresent = props?.styleOptionsNotPresent || false;

  const [finishSelectedValue, setFinishSelectedValue] = useState()
  const [colorDefaultDetails, setColorDefaultDetails] = useState([])
  const [tempIndex, setTempIndex] = useState(0)
  const [ProductDescriptionDetail, setProductDescriptionDetail] = useState(
    props?.ProductDescriptionDetail_s
  )
  const [updatedImageDetails, setUpdatedImageDetails] = useState(undefined)
  const allowMaxColor = 7
  const notallowFinishValue = 1
  const handleShapeSizeDesignImageUrl = (
    productDescriptions,
    productDetailImageURLs
  ) =>
    productDescriptions.reduce((acc, item) => {
      const cloneProductDetailImageURLs = productDetailImageURLs?.map(
        productDetailImageURL => productDetailImageURL.split("|")[0]
      )
      const addedImageUrls = acc?.map(
        productDetailImageURL => productDetailImageURL.split("|")[0]
      )
      const findx = cloneProductDetailImageURLs.findIndex(aa => aa === item)
      if (
        cloneProductDetailImageURLs.includes(item) &&
        !addedImageUrls.includes(item)
      ) {
        acc.push(productDetailImageURLs[findx])
      } else if (
        !cloneProductDetailImageURLs.includes(item) &&
        !addedImageUrls.includes(item) &&
        findx === -1
      ) {
        styleOptionsNotPresent = true
        return [...acc]
      }
      return acc.flat()
    }, [])
  const descriptionDetails_ = descriptionDetails?.filter(
    (_, idx) => idx % 2 === 0
  )
  const shapeImageUrls = imageDetails?.filter((_, idx) => idx % 2 === 0)
  const updatedImageDetailsFn = useCallback(
    () => handleShapeSizeDesignImageUrl(descriptionDetails_, shapeImageUrls),
    [shapeImageUrls]
  )
  const updatedImageDetails_ = updatedImageDetailsFn()

  const shapeSizeDesignImageDescription =
    updatedImageDetails &&
    updatedImageDetails
      ?.filter((_, idx) => idx % 2 === 0)
      .map(imageDetail => {
        const split = imageDetail?.split("|")
        return {
          code: split[0],
          image: split[1],
        }
      })
  const [descriptionDetail, setDescriptionDetail] = useState("")
  const [descripritionWithImageDetail, setDescripritionWithImageDetail] =
    useState({})
  useEffect(() => {
    const configFn = async () => {
      const config = await getConfig()
      setCONFIG(config)
    }
    configFn()
  }, [])
  const plpServletPath = _get(CONFIG, "plpServletPath", "")
  const selectedCategoriesForStandaloneListprice = [
    "Trims & Moldings",
    "Field Tiles",
    "Mosaics",
  ]
  useEffect(() => {
    const configFn = async () => {
      const { general } = await getConfig()
      setGeneral(general)
    }
    configFn()
  }, [])

  useEffect(() => {
    const handleShortned = async () => {
      const discontinueShortened = await getShortenedUrl(
        authorData?.discontinuedCTALink
      )
      setDiscontinuedCTALink(discontinueShortened)
    }
    handleShortned()
    setProductDescriptionDetail(props?.ProductDescriptionDetail_s)
  }, [authorData])

  useEffect(() => {
    setDescriptionDetail(
      descriptionDetails_?.length > 0 ? descriptionDetails_[0] : ""
    )
    setUpdatedImageDetails(updatedImageDetails_)
    setDescripritionWithImageDetail(
      shapeSizeDesignImageDescription?.length > 0
        ? shapeSizeDesignImageDescription[0]
        : ""
    )
  }, [imageDetails])
  const dispatch = useDispatch()

  let queryParams = new URLSearchParams(window.location.search)

  const productDescriptionDetailFormat = (productDescriptionDetail = "") => {
    const numbers = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
    const toArr = productDescriptionDetail?.split("")
    return toArr
      ?.map((item, idx) => {
        if (
          numbers.includes(parseInt(item)) &&
          !numbers.includes(parseInt(toArr[idx + 1]))
        ) {
          return item + "\\"
        } else return item
      })
      .join("")
  }
  const handleShapeSizeSelectChange = async (
    selectedItem,
    imageUrl = null,
    isOverlay = false
  ) => {
    setDescriptionDetail(selectedItem)
    setProductDescriptionDetail(selectedItem)
    setDescripritionWithImageDetail(selectedItem)
    const { data } = await apim.get(`/search/plp`, {
      params: {
        q: "*:*",
        fq: [
          `Collapse_Field_s:"${ProductLocalCategory} ${productCollection}"`,
          `isCollapsedPDP_b:true`,
          `ProductDescriptionDetail_s:"${productDescriptionDetailFormat(
            selectedItem
          )}"`,
        ],
        fl: "slug_s",
        profilename: `profile_${lwAppName.toLowerCase()}_PDP`,
        collections: lwAppName.toLowerCase(),
      },
      paramsSerializer: params =>
        qs.stringify(params, { arrayFormat: "repeat", encode: true }),
    })
    const slug = data?.response?.docs[0]?.["slug_s"]
    let datalayerObj = {
      title: isOverlay
        ? i18n?.productSelectStyleShapeApplyBtn?.toLowerCase()
        : "style selection",
      productInfo: JSON.stringify({
        style: selectedItem,
        defaultImageName: imageUrl,
      })?.toLowerCase(),
    }
    if (isOverlay) {
      datalayerObj.sysOverlayObj = {
        overlayTitle: "select your style overlay",
        overlayType: i18n?.productSelectStyleShapeLabel?.toLowerCase(),
        sysVal: selectedItem?.toLowerCase(),
      }
    } else {
      datalayerObj.shapeVal = selectedItem?.toLowerCase()
    }
    addDataLayer(datalayerObj)
    if (ProductLocalCategory && plpServletPath) {
      let pdpPageDetails = plpServletPath.find(el =>
        el.categories.includes(ProductLocalCategory)
      )

      const redirect = pdpPageDetails
        ? pdpPageDetails?.url
          ? getShortenedUrlwithGeneral(
              pdpPageDetails.url + "/" + slug + ".html",
              general
            )
          : ""
        : ""
      window.location = redirect
    }
  }

  useEffect(() => {
    const skuId = queryParams.has("skuId") ? queryParams.get("skuId") : ""
    skuId && dispatch(updateVariantSkuInTabDetails({ sku: skuId }))
    if (finishSelectedValue && colorDefaultDetails.length) {
      !skuId && queryParams.set("skuId", colorDefaultDetails[0].split("|")[2])
      queryParams.set("finish", finishSelectedValue)
      window.history.replaceState(null, null, "?" + queryParams.toString())
    }
  }, [finishSelectedValue])

  const finishFilterChange = val => {
    setFinishSelectedValue(val)
    addDataLayer({
      title: "finish selection",
      productInfo: props?.analyticsProductInfo,
      finishVal: val?.toLowerCase(),
    })
    if (val?.toLowerCase() === SHOWALL.toLowerCase()) {
      const colorBaseFinish = getColorBasedFinish(val)
      queryParams.set("finish", val)
      const modifiedColorsData = modifyColorData(props?.colorDetails, 1, "")
      let clonedColorsData = [...modifiedColorsData]
      if (clonedColorsData && clonedColorsData.length > 0) {
        setColorsPopUp(clonedColorsData)
        setColors(modifiedColorsData)
      }
      setColorDefaultDetails(props?.colorDetails)
      setFinishSelectedValue(val)
      const skuId = queryParams.has("skuId") ? queryParams.get("skuId") : ""
      if (val && colorBaseFinish?.length) {
        queryParams.set("skuId", skuId)
        queryParams.set("finish", val)
        window.history.replaceState(null, null, "?" + queryParams.toString())
      }
      const colorsItem =
        modifiedColorsData?.find(
          colorDetail => colorDetail["skuId"] === skuId
        ) || {}
      skuId &&
        getNewVarients(
          colorsItem["skuId"] ? colorsItem["skuId"] : "",
          colorsItem
        )
      let colorDataDetails =
        modifiedColorsData?.find(colorData => colorData?.skuId === skuId) ?? {}
      if (colorDataDetails && Object.keys(colorDataDetails)?.length > 0) {
        setColorHeading(
          colorDataDetails["name"] + " - " + colorDataDetails["finishName"]
        )
        colorDataDetails["isActive"] = true
      }
      return
    }
    let colorBaseFinish = getColorBasedFinish(val)
    setColorDefaultDetails(colorBaseFinish)
    if (val && colorBaseFinish?.length) {
      queryParams.set("skuId", colorBaseFinish[0].split("|")[2])
      queryParams.set("finish", val)
      window.history.replaceState(null, null, "?" + queryParams.toString())
    }
    let tmpColorData =
      colorBaseFinish.length > 0 ? modifyColorData(colorBaseFinish, 1, "") : ""
    let colorDataDetails = [...tmpColorData]
    if (colorDataDetails && colorDataDetails?.length > 0) {
      setColorHeading(
        `${colorDataDetails[0]["name"]} ${
          colorDataDetails[0]["finishName"] !== NO_FINISH_TYPE
            ? ` - ${colorDataDetails[0]["finishName"]}`
            : ""
        }`
      )
      colorDataDetails[0]["isActive"] = true
    }
    setColorsPopUp(tmpColorData)
    setColors(colorDataDetails)
    const skuId = queryParams.has("skuId") ? queryParams.get("skuId") : ""
    const colorsItem =
      colorDataDetails?.find(colorDetail => colorDetail["skuId"] === skuId) ||
      {}
    skuId &&
      getNewVarients(colorsItem["skuId"] ? colorsItem["skuId"] : "", colorsItem)
  }
  const finishTypeFromSkuId = (
    skuId = "",
    colorDetails = [],
    colorFinishTypeDetails = []
  ) => {
    let finishVal = ""
    const colorDetail = Array.isArray(colorDetails)
      ? colorDetails?.filter(cd => cd?.split("|")[2] === skuId)[0]
      : ""
    const findFinishVal = Array.isArray(colorFinishTypeDetails)
      ? colorFinishTypeDetails?.find(
          cftd => cftd?.split("|")[1] === colorDetail?.split("|")[0]
        )
      : ""
    finishVal = findFinishVal?.split("|")[0]
    return finishVal
  }
  const getColorBasedFinish = tmpFinishVal => {
    let finalList = []
    let finalColorFamilyList = []
    let finishVal = ""
    const { colorDetails = [], colorFinishTypeDetails = [] } = props
    const isShowAll = finishType?.includes(SHOWALL)
    if (!tmpFinishVal && queryParams.has("skuId")) {
      const skuId = queryParams.get("skuId")
      finishVal = finishTypeFromSkuId(
        skuId,
        colorDetails,
        colorFinishTypeDetails
      )
      finishVal = isShowAll ? SHOWALL : finishVal
      setFinishSelectedValue(finishVal)
    } else if (!tmpFinishVal && !queryParams.has("skuId")) {
      const skuId = props?.colorDetails?.[0]?.split("|")[2]
      finishVal = finishTypeFromSkuId(
        skuId,
        colorDetails,
        colorFinishTypeDetails
      )
      finishVal = isShowAll ? SHOWALL : finishVal
      setFinishSelectedValue(finishVal)
    } else {
      finishVal = tmpFinishVal
    }
    const updatedFinishVal = finishVal?.replaceAll("+", " ")
    if (updatedFinishVal?.toLowerCase() === SHOWALL.toLowerCase()) {
      const finalColorFamily =
        props?.colorFamily &&
        props.colorFamily.length &&
        props.colorFamily?.reduce((acc, item) => {
          const [name] = item.split("|")
          if (acc[name]) {
            acc[name] += 1
          } else acc[name] = 1
          return acc
        }, {})
      const updatedColorFamilyCount = finalColorFamily
        ? Object.entries(finalColorFamily).map(([k, v]) => `${k}|${v}`)
        : []
      SetColorFamilyCount(updatedColorFamilyCount)
      setColorFamily(props?.colorFamily)
      return props?.colorDetails
    }
    props?.colorFinishTypeDetails?.length > 0 && updatedFinishVal
      ? props?.colorFinishTypeDetails.map(item => {
          let tmpColorFinish = item.split("|")
          if (tmpColorFinish[0] === updatedFinishVal) {
            let tempColor = tmpColorFinish[1]
            props?.colorDetails?.length > 0 &&
              props?.colorDetails.filter(list => {
                const colorDetail = list.split("|")
                const colorDetailLength = colorDetail.length
                const listFinish = colorDetail[colorDetailLength - 1]
                if (
                  list.indexOf(tempColor) > -1 &&
                  tmpColorFinish[0] === listFinish &&
                  !finalList.includes(list)
                ) {
                  finalList.push(list)
                  return true
                }
              })
            props?.colorFamily?.length &&
              props?.colorFamily.some(list => {
                if (
                  list.indexOf(tempColor) > -1 &&
                  !finalColorFamilyList.includes(list)
                ) {
                  finalColorFamilyList.push(list)
                  return true
                }
              })
          }
          return ""
        })
      : ""
    const finalColorFamily = finalColorFamilyList.reduce((acc, item) => {
      const [name] = item.split("|")
      if (acc[name]) {
        acc[name] += 1
      } else acc[name] = 1
      return acc
    }, {})
    const updatedColorFamilyCount = Object.entries(finalColorFamily).map(
      ([k, v]) => `${k}|${v}`
    )
    SetColorFamilyCount(updatedColorFamilyCount)
    setColorFamily(finalColorFamilyList)
    return finalList
  }
  useEffect(() => {
    setTimeout(() => {
      setTooltipData(props.selectMoreTooltipData)
    }, 3000)
  }, [props?.selectMoreTooltipData])

  useEffect(() => {
    setDiscontinuedColors(colorDiscontinuedVarients)
  }, [colorDiscontinuedVarients])

  useEffect(() => {
    if (colors.length === 0) {
      let colorBaseFinish = getColorBasedFinish("")
      setColorDefaultDetails(colorBaseFinish)
      let tmpColorInfo =
        colorBaseFinish.length > 0
          ? modifyColorData(colorBaseFinish, 1, "")
          : ""
      let colorDataDetails = [...tmpColorInfo]
      if (colorDataDetails && colorDataDetails?.length > 0) {
        let chkIsActiveColor = colorDataDetails.some(item => {
          return item["isActive"] === true
        })
        if (chkIsActiveColor === false) {
          colorDataDetails[0]["isActive"] = true
          setColorHeading(
            `${colorDataDetails[0]["name"]} ${
              colorDataDetails[0]["finishName"] !== NO_FINISH_TYPE
                ? ` - ${colorDataDetails[0]["finishName"]}`
                : ""
            }`
          )
        }
      }
      setColorsPopUp(colorDataDetails)
      setColors(colorDataDetails)
      const skuId = queryParams.has("skuId") ? queryParams.get("skuId") : ""
      const colorsItem =
        colorDataDetails?.find(colorDetail => colorDetail["skuId"] === skuId) ||
        {}
      skuId &&
        getNewVarients(
          colorsItem["skuId"] ? colorsItem["skuId"] : "",
          colorsItem
        )
    } else if (colors && colors?.length > 0) {
      let chkIsActiveColor = colors.some(item => {
        return item["isActive"] === true
      })
      if (chkIsActiveColor === false) {
        colors[0]["isActive"] = true
        setColors(colors)
      }
      const skuId = queryParams.has("skuId") ? queryParams.get("skuId") : ""
      const colorsItem =
        colors?.find(colorDetail => colorDetail["skuId"] === skuId) || {}
      skuId &&
        getNewVarients(
          colorsItem["skuId"] ? colorsItem["skuId"] : "",
          colorsItem
        )
    }

    let colorFinishdata = []
    if (props?.finishPopUpData !== undefined && finish.length === 0) {
      let i
      for (i = 0; i < props?.finishPopUpData.length; i = i + 1) {
        if (props?.finishPopUpData[i].indexOf("|") > -1) {
          let getFinishArray = props?.finishPopUpData[i].split("|")
          let tmpData = { name: getFinishArray[0], count: getFinishArray[1] }
          colorFinishdata.push(tmpData)
        }
      }
      setFinish(colorFinishdata)
    }
    let imagedata = []
    if (updatedImageDetails !== undefined) {
      for (let i = 0; i < updatedImageDetails?.length; i++) {
        if (updatedImageDetails[i].indexOf("|") > -1) {
          let getDetailsArray = updatedImageDetails[i].split("|")
          let isActiveNew =
            ProductDescriptionDetail === getDetailsArray[0]
              ? true
              : !props?.ProductDescriptionDetail_s && i === 0
              ? true
              : false
          !props?.ProductDescriptionDetail_s && i === 0
            ? setShapeHeading(getDetailsArray[0])
            : ""
          isActiveNew === true ? setShapeHeading(getDetailsArray[0]) : ""
          let tmpData = {
            name: getDetailsArray[0],
            src: getDetailsArray[1],
            count: imageDetails[i + 1],
            isActive: isActiveNew,
          }
          imagedata.push(tmpData)
        }
      }
      setImage(imagedata)
    }
    let availableColorsData = []
    let getColorsName = false
    let availableColors = props?.availableColors
    if (
      availableColors !== undefined &&
      availableColors?.length > 0 &&
      getColorsName === false &&
      isColorDiscontinued &&
      !isDiscontinued
    ) {
      for (
        let i = 0;
        i < availableColors.length && getColorsName === false;
        i = i + 1
      ) {
        if (
          availableColors[i]["discontinuedColor"] !== undefined &&
          !availableColors[i]["discontinuedColor"]
        ) {
          let tmpSkuId = availableColors[i]["id"]
          let colorInfoTmp = props?.colorDetails
          if (colorInfoTmp !== undefined && colorInfoTmp?.length > 0) {
            for (
              let k = 0;
              k < colorInfoTmp.length && getColorsName === false;
              k = k + 1
            ) {
              if (colorInfoTmp[k].indexOf("|") > -1) {
                let getColorArray = colorInfoTmp[k].split("|")
                if (
                  getColorArray[2] === tmpSkuId &&
                  getColorArray[0] === availableColors[i]["label"]
                ) {
                  let tmpData = {
                    skuId: getColorArray[2],
                    colorName: getColorArray[0],
                  }
                  availableColorsData.push(tmpData)
                  getColorsName = true
                }
              }
            }
          }
        }
      }
      setAvailableColors(availableColorsData)
    }
  }, [
    imageDetails,
    updatedImageDetails,
    props?.colorDetails,
    props?.finishPopUpData,
    props?.availableColors,
    ProductDescriptionDetail,
    currentSku,
  ])

  const selectStyleTooltipHandler = (
    shareTooltip,
    colorTooltip,
    finishTooltip,
    vanityTooltip,
    msg
  ) => {
    setSelectStyleTooltip({
      shareTooltip,
      colorTooltip,
      finishTooltip,
      vanityTooltip,
    })
    addDataLayer({
      title: "info icon mouseover",
      productInfo: props?.analyticsProductInfo,
      toolTipProps: {
        isToolTip: true,
        toolTipValue: msg?.toLowerCase(),
      },
    })
  }

  const modifyColorData = (dataList, indexIncreaseBy, newSku) => {
    let colorsData = []
    if (dataList !== undefined && dataList.length > 0) {
      let i
      for (i = 0; i < dataList.length; i = i + indexIncreaseBy) {
        if (dataList[i].indexOf("|") > -1) {
          let getColorArray = dataList[i].split("|")
          let colorExpiredDate
          const expirationDateStr = getColorArray[4]
          const currentDate = new Date()
          if (expirationDateStr && !isNaN(Date.parse(expirationDateStr))) {
            const expiredDate = new Date(expirationDateStr)
            colorExpiredDate = expiredDate <= currentDate ? true : false
          }
          if (expirationDateStr === "false" || !colorExpiredDate) {
            let skuActive = newSku
              ? getColorArray[2] && newSku === getColorArray[2]
                ? true
                : false
              : false
            let chkIsActive = skuActive ? true : false
            chkIsActive
              ? setColorHeading(
                  `${getColorArray[0]} ${
                    getColorArray[6] !== NO_FINISH_TYPE
                      ? ` - ${getColorArray[6]}`
                      : ""
                  }`
                )
              : ""
            let tmpColorsData = {
              name: getColorArray[0],
              src: getColorArray[1],
              skuId: getColorArray[2],
              isActive: chkIsActive,
              finishName: getColorArray[6],
            }
            colorsData.push(tmpColorsData)
          }
        }
      }
    }
    return colorsData
  }
  const openModal = checkType => {
    checkType === "shape" ? setModalShape(true) : setModalShape(false)
    checkType === "color" ? setModalColor(true) : setModalColor(false)
    setShowModal(true)
    document.body.classList.add("modal-open")
    document.body.classList.add("gbh-of-scroll")
  }
  const closeModal = () => {
    setShowModal(false)
    document.body.classList.remove("modal-open")
    document.body.classList.remove("gbh-of-scroll")
  }
  const openFilter = () => {
    if (showFilter) {
      setModalFilter(false)
    } else {
      setModalFilter(true)
    }
  }
  const updateLabelHeading = (id, currentVal) => {
    const item = document.getElementById(id);
    if(item && currentVal?.length >= 0) {
      item.innerHTML = currentVal
    }
  }
  const updateShapeImagePreview = currentVal => {
    const item = document.getElementById("product-select-style__modal-image-preview");
    if (item && currentVal?.length >= 0) {
      item.src = currentVal
    }
  }

  const applySelectedShape = (index) => {
    handleShapeSizeSelectChange(image[index]["name"], image[index]["src"], true)
    closeModal()
  }

  const applyBtn = () => {
    handleShapeSizeSelectChange(image[tempIndex]["name"], image[tempIndex]["src"], true)
    closeModal()
  }

  const showActivePreview = (currNodeRef, className, isShape, itemIndex) => {
    let allNodeRef = document.querySelectorAll("." + className)
    setTempIndex(itemIndex)
    try {
      let i
      for (i = 0; i < allNodeRef.length; i++) {
        if (
          allNodeRef[i] &&
          allNodeRef[i].classList &&
          allNodeRef[i].classList.contains(className + "-active")
        ) {
          allNodeRef[i].classList.remove(className + "-active")
        }
      }
      document.getElementById(currNodeRef).classList.add(className + "-active")
      if (
        document.getElementById(currNodeRef) &&
        Number(window.outerWidth) < 1024
      ) {
        let tmpSrc = document
          .getElementById(currNodeRef)
          ?.getElementsByTagName("img")[0]
          ?.getAttribute("src")
        if (isShape) {
          tmpSrc && tmpSrc !== undefined
            ? document.getElementById(
                "product-select-style__modal-image-preview"
              )
              ? (document.getElementById(
                  "product-select-style__modal-color-image-preview"
                ).src = tmpSrc)
              : ""
            : ""
        } else {
          tmpSrc && tmpSrc !== undefined
            ? document.getElementById(
                "product-select-style__modal-color-image-preview"
              )
              ? (document.getElementById(
                  "product-select-style__modal-color-image-preview"
                ).src = tmpSrc)
              : ""
            : ""
        }
      }
    } catch (error) {
      console.error(error)
    }
  }

  const getNewVarients = async (
    filterVal,
    colorsItem = null,
    isClicked = false
  ) => {
    if (filterVal) {
      let finishSelectedOption = finishSelectedValue ? finishSelectedValue : ""
      setSkuVariant(filterVal, finishSelectedOption)
      setActiveSku(filterVal)
    }

    const allList = filterVal && priceData[filterVal]
    const pList =
      (allList &&
      Object.keys(allList).length &&
      selectedCategoriesForStandaloneListprice.includes(ProductLocalCategory)
        ? allList?.ctStandaloneGstPersona
        : allList?.ctPricelistGstPersona) || priceData?.lwAnyPrice
    filterVal &&
      dispatch(
        updateVariantSkuInTabDetails({
          sku: filterVal,
          listPrice: (pList && pList.toFixed(2)) || 0,
        })
      )
    const selecetedProductinfo = JSON.parse(props?.analyticsProductInfo)
    selecetedProductinfo.defaultImageName = `${props?.swatchUrl}${colorsItem?.src}`
    selecetedProductinfo.productColor = colorsItem?.name
    selecetedProductinfo.productID = colorsItem?.skuId
    if (!authorData?.disableEcommerce) {
      getStock(colorsItem?.skuId)?.then(qty => {
        selecetedProductinfo.productStatus =
          qty > 0 ? "in stock" : "out of stock"
      })
    } else {
      selecetedProductinfo.productStatus = "n/a"
    }
    isClicked &&
      addDataLayer({
        title: "color selection",
        colorVal:
          `${colorsItem?.name} - ${colorsItem?.finishName}`?.toLowerCase(),
        productInfo: JSON.stringify(selecetedProductinfo)?.toLowerCase(),
      })
  }

  const modalColorApplyBtn = (
    className,
    indexName,
    colorFinishName,
    imageSrc
  ) => {
    let tagSelected = document.querySelector("." + className)
    let skuId = tagSelected?.getAttribute(indexName)
    const colorFinishValue = tagSelected
      ?.getAttribute(colorFinishName)
      ?.toLowerCase()
    const colorValue = colorFinishValue?.split("-")?.[0]?.trim()
    const imageItemSrc = tagSelected?.getAttribute(imageSrc)?.toLowerCase()
    const selecetedProductinfo = JSON.parse(props?.analyticsProductInfo)
    selecetedProductinfo.defaultImageName = `${props?.swatchUrl}${imageItemSrc}`
    selecetedProductinfo.productColor = colorValue
    selecetedProductinfo.productID = skuId
    addDataLayer({
      sysOverlayObj: {
        overlayTitle: "select your style overlay",
        overlayType:
          `${i18n?.productSelectStyleModalColorTitle}:`?.toLowerCase(),
        sysVal: colorFinishValue,
      },
      title: i18n?.productSelectStyleShapeApplyBtn?.toLowerCase(),
      productInfo: JSON.stringify(selecetedProductinfo)?.toLowerCase(),
    })
    if (skuId !== "" && skuId !== undefined) {
      let finishSelectedOption = finishSelectedValue ? finishSelectedValue : ""
      setSkuVariant(skuId, finishSelectedOption)
      closeModal()
    } else {
      return ""
    }
  }
  useEffect(() => {
    let skuIdParam = ""
    let finishParam = ""
    window.location.search
      .slice(1)
      .split("&")
      .forEach(getElement => {
        if (getElement === "") return
        let newParam = getElement.split("=")
        if (newParam.length >= 2) {
          if (newParam[0] === "skuId") {
            skuIdParam = decodeURIComponent(newParam[1])
          }
          if (newParam[0] === "finish") {
            finishParam = decodeURIComponent(newParam[1])
          }
        }
      })
    let urlSku = skuIdParam ? skuIdParam : ""

    let finish = finishParam ? finishParam : ""

    if (urlSku) {
      const updatedFinish = finish?.replaceAll("+", " ")
      finish && setFinishSelectedValue(updatedFinish)
      let colorBaseFinish = getColorBasedFinish(finish)
      let tmpColorData =
        colorBaseFinish?.length > 0
          ? modifyColorData(colorBaseFinish, 1, urlSku)
          : ""
      if (tmpColorData && tmpColorData?.length > 0) {
        let chkIsActiveColor = tmpColorData.some(item => {
          return item["isActive"] === true
        })
        if (chkIsActiveColor === false) {
          tmpColorData[0]["isActive"] = true
        }
      }
      setColors(tmpColorData)
      setColorsPopUp(tmpColorData)
    }
  }, [currentSku, props?.finishType])
  return (
    <div
      className={`product-select-style__main-container ${
        !isDiscontinued &&
        !isColorDiscontinued &&
        (image.length || finishType?.length || colors.length)
          ? "product-select-style__devider--block"
          : ""
      }`}
    >
      <div
        className={
          props.comboSkuDetails && props.comboSkuDetails.length > 0
            ? "product-select-style curated-style"
            : "product-select-style"
        }
      >
        <SelectYourStyleView
          handleShapeSizeSelectChange={handleShapeSizeSelectChange}
          descriptionDetail={descriptionDetail}
          ProductDescriptionDetail={ProductDescriptionDetail}
          descriptionDetails={descriptionDetails_}
          selectStyleTooltipHandler={selectStyleTooltipHandler}
          finishFilterChange={finishFilterChange}
          styleTooltip={styleTooltip}
          setSelectStyleTooltip={setSelectStyleTooltip}
          finishType={finishType}
          finishSelectedValue={finishSelectedValue}
          tooltip={tooltip}
          i18n={i18n}
          tooltipdata={tooltipdata}
          colorHeading={colorHeading}
          notallowFinishValue={notallowFinishValue}
          authorData={authorData}
          colors={colors}
          getNewVarients={getNewVarients}
          swatchUrl={props?.swatchUrl}
          updateLabelHeading={updateLabelHeading}
          openModal={openModal}
          colorFamily={colorFamily}
          colorFamilyCount={colorFamilyCount}
          productTitle={productTitle}
          isDiscontinued={isDiscontinued}
          isColorDiscontinued={isColorDiscontinued}
          isShape={isShape}
          image={image}
          imageDetails={imageDetails}
          shapeSizeDesignImageDescription={shapeSizeDesignImageDescription}
          showModal={showModal}
          isColor={isColor}
          colorsPopUp={colorsPopUp}
          ProductLocalCategory={ProductLocalCategory}
          showActivePreview={showActivePreview}
          updateShapeImagePreview={updateShapeImagePreview}
          closeModal={closeModal}
          modalColorApplyBtn={modalColorApplyBtn}
          openFilter={openFilter}
          applyBtn={applyBtn}
          showFilter={showFilter}
          allowMaxColor={allowMaxColor}
          colorsDiscontinuedVarients={colorsDiscontinuedVarients}
          currentSku={currentSku}
          finalAvailableColors={finalAvailableColors}
          shapeHeading={shapeHeading}
          descripritionWithImageDetail={descripritionWithImageDetail}
          comboSkuDetails={props.comboSkuDetails}
          productCategoryType={props.productCategoryType}
          NO_FINISH_TYPE={NO_FINISH_TYPE}
          activeSku={activeSku}
          isCollapsedPDP={isCollapsedPDP}
          discontinuedCTALink={discontinuedCTALink}
          presetConfig={props.presetConfig}
          accountName={props?.accountName}
          productImages={productImages}
          applySelectedShape={applySelectedShape}
          styleOptionsNotPresent={styleOptionsNotPresent}
        />
      </div>
    </div>
  )
}

export default SelectYourStyle
